export default "__VITE_PUBLIC_ASSET__c2dda2e5__"